import { useTranslation } from 'react-i18next'
import React from 'react'

import { Col, Grid } from '../../../../packages/kiti/components/structure/Grid'
import { useFolders } from './_load/FoldersLoader'
import { useModalData } from '../../../../components/modals/ModalsContext'
import DataTable from '../../../../packages/kiti/components/table/DataTable'
import EditableFolder from '../../../../containers/folders/EditableFolder'
import Icon from '../../../../packages/kiti/components/shapes/Icon'
import IconCount from '../../../../components/shapes/IconCount'
import Link from '../../../../packages/kiti/components/actions/Link'
import Text from '../../../../packages/kiti/components/presentation/Text'
import TriggersTable from '../triggers/TriggersTable'
import { getLocalStorageKey, addOpenFolder, removeOpenFolder, getOpenFolders } from '../_helper/localStorage'

const hasOnlyDefaultFolder = folders => {
  if (!folders) return false
  if (!folders.length) return false
  if (folders?.length > 1) return false
  const [firstFolder] = folders
  return firstFolder?.default
}

const FolderTable = () => {
  const { t } = useTranslation('triggers')
  const { entities } = useModalData() || {}
  const folders = useFolders()

  const localStorageKey = getLocalStorageKey(entities)

  if (hasOnlyDefaultFolder(folders)) {
    return <TriggersTable folder={folders[0]} inPanel />
  }

  const columns = [
    {
      label: t('name'),
      sortIndex: false,
      dataIndex: 'name',
      flex: 3,
      render: (value, record, _index, { toggleExpand, isExpanded }) => (
        <Link onClick={record.triggersCount ? toggleExpand : undefined}>
          <Grid gap={0.5} align="center">
            <Col>
              <Icon
                name={record.triggersCount ? (isExpanded ? 'BsFillCaretDownFill' : 'BsCaretRightFill') : 'BsDashLg'}
                color={record.triggersCount ? 'dark2' : 'light5'}
              />
            </Col>
            <Col>
              <EditableFolder record={record} field="name">
                <Text bold color={record.triggersCount ? 'dark1' : 'light5'}>
                  {value}
                </Text>
              </EditableFolder>
            </Col>
          </Grid>
        </Link>
      ),
      renderExpand: record => <TriggersTable folder={record} hideHeader />,
      onExpandOrCollapse: (record, expanded) => {
        expanded ? addOpenFolder(record.id, localStorageKey) : removeOpenFolder(record.id, localStorageKey)
      },
      initialExpandValue: record => {
        return getOpenFolders(localStorageKey).hasOwnProperty(record.id)
      }
    },

    {
      label: t('quantity'),
      dataIndex: 'triggersCount',
      flex: 1,
      sortIndex: false,
      render: value => <IconCount value={value} icon="BsFolder2Open" color={value ? 'dark3' : 'light5'} />
    }
  ]

  return <DataTable rowKey="id" columns={columns} data={folders} inPanel size="medium" />
}

export default FolderTable
